"use client";

import { c as _c } from "react/compiler-runtime";
import { type CartOutputDto, CouponStatus } from "@sticker-giant/sg-frontend-common";
import { type MutationState, useMutationState } from "@tanstack/react-query";
import { type ChangeEvent, type FormEvent, useState } from "react";
import { InputGroup, InputGroupAddon, InputGroupButton, InputGroupInput } from "@/components/ui/input-group";
import { CustomerFacingErrorMessages } from "@/constants/CustomerFacingErrorMessages";
import { getPromoCodeErrorMessage } from "@/lib/promo-code-error";
import { applyCouponMutationKey, useApplyCoupon } from "@/mutations/useApplyCoupon";
export function PromoCodeInput() {
  const $ = _c(30);
  const [code, setCode] = useState("");
  const [isEmptyError, setIsEmptyError] = useState(false);
  const [showResult, setShowResult] = useState(true);
  const applyCoupon = useApplyCoupon();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      filters: {
        mutationKey: applyCouponMutationKey
      },
      select: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = useMutationState(t0);
  let handleChange;
  let handleSubmit;
  let t2;
  if ($[1] !== applyCoupon || $[2] !== code || $[3] !== isEmptyError || $[4] !== showResult || $[5] !== t1) {
    const lastAttempt = t1.at(-1);
    let t3;
    if ($[9] !== applyCoupon || $[10] !== code) {
      t3 = function handleSubmit(event) {
        event.preventDefault();
        const trimmed = code.trim();
        if (!trimmed) {
          setIsEmptyError(true);
          return;
        }
        setShowResult(true);
        applyCoupon.mutate({
          code: trimmed
        }, {
          onSuccess: updatedCart => {
            if (updatedCart.couponStatus === CouponStatus.APPLIED) {
              setCode("");
            }
          }
        });
      };
      $[9] = applyCoupon;
      $[10] = code;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    handleSubmit = t3;
    let t4;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = function handleChange(event_0) {
        setCode(event_0.target.value);
        setIsEmptyError(false);
        setShowResult(false);
      };
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    handleChange = t4;
    const getErrorMessage = function getErrorMessage() {
      if (isEmptyError) {
        return CustomerFacingErrorMessages.promoCodeRequired;
      }
      if (!showResult || !lastAttempt) {
        return null;
      }
      if (lastAttempt.data?.couponFailureReason) {
        return getPromoCodeErrorMessage(lastAttempt.data.couponFailureReason);
      }
      if (lastAttempt.error) {
        return CustomerFacingErrorMessages.unableToApplyPromo;
      }
      return null;
    };
    t2 = getErrorMessage();
    $[1] = applyCoupon;
    $[2] = code;
    $[3] = isEmptyError;
    $[4] = showResult;
    $[5] = t1;
    $[6] = handleChange;
    $[7] = handleSubmit;
    $[8] = t2;
  } else {
    handleChange = $[6];
    handleSubmit = $[7];
    t2 = $[8];
  }
  const errorMessage = t2;
  let t3;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <label htmlFor="cart-promo-code" className="sr-only">Promo Code</label>;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== code || $[15] !== handleChange) {
    t4 = <InputGroupInput id="cart-promo-code" placeholder="Promo Code" value={code} onChange={handleChange} />;
    $[14] = code;
    $[15] = handleChange;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== applyCoupon.isPending) {
    t5 = <InputGroupAddon align="inline-end"><InputGroupButton type="submit" variant="default" isSubmitting={applyCoupon.isPending}>Apply</InputGroupButton></InputGroupAddon>;
    $[17] = applyCoupon.isPending;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t4 || $[20] !== t5) {
    t6 = <InputGroup>{t4}{t5}</InputGroup>;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== handleSubmit || $[23] !== t6) {
    t7 = <form onSubmit={handleSubmit}>{t3}{t6}</form>;
    $[22] = handleSubmit;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== errorMessage) {
    t8 = errorMessage && <p className="pt-1 text-sm text-red-600">{errorMessage}</p>;
    $[25] = errorMessage;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== t7 || $[28] !== t8) {
    t9 = <div>{t7}{t8}</div>;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  return t9;
}
function _temp(mutation) {
  return mutation.state as MutationState<CartOutputDto>;
}